export function findLayerByName(mapInstance: any, name: string) {
  if (!mapInstance || !name) return false

  const layers = mapInstance.current?.getLayers().getArray() || []
  const find = layers.find((layer: any) => layer.get('name') === name)

  return find
}
